import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 480 480" height="100%" fill="none" {...props}>
        <Path
            fill="#fff"
            d="M80.578 226.201h109.749v-86.819l87.936 86.819-87.936 86.146v44.419h106.341V226.201h98.16V123.902H80.578v102.299Z"
        />
    </Svg>
);
export default SvgComponent;
